import type { UseCaseConfig, UseCaseSlug } from "./types";
import { educationConfig } from "./verticals/education";
import { customerMarketingConfig } from "./verticals/customer-marketing";
import { industryReportingConfig } from "./verticals/industry-reporting";
import { localGovernmentConfig } from "./verticals/local-government";

/**
 * Single source of truth for which use-case landing pages exist. Adding a
 * vertical = one new config file + one entry here. App.tsx matches
 * `/use-cases/<slug>` against this map; vite.config.ts derives per-route
 * SEO metadata from it.
 */
export const useCaseRegistry: Record<UseCaseSlug, UseCaseConfig> = {
  [educationConfig.slug]: educationConfig,
  [customerMarketingConfig.slug]: customerMarketingConfig,
  [industryReportingConfig.slug]: industryReportingConfig,
  [localGovernmentConfig.slug]: localGovernmentConfig,
};

export function getUseCaseConfig(slug: string): UseCaseConfig | null {
  // Use own-property check so inherited keys (`__proto__`, `constructor`, etc.)
  // don't resolve to prototype values when the slug comes from URL input.
  return Object.prototype.hasOwnProperty.call(useCaseRegistry, slug)
    ? useCaseRegistry[slug]
    : null;
}

export function listUseCases(): UseCaseConfig[] {
  return Object.values(useCaseRegistry);
}
